// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tabs-module__main--OAY_W {
    display: flex;
    gap: 12px;
}

.Tabs-module__tab--nCgpc {
    --padding-bottom: 6px;
    --border-bottom-width: 2px;
    padding-bottom: var(--padding-bottom);
    cursor: pointer;
}

.Tabs-module__tab--nCgpc.Tabs-module__active--JvZ9G {
    border-bottom: var(--border-bottom-width) solid var(--color-secondary-dark);
    padding-bottom: calc(var(--padding-bottom) - var(--border-bottom-width));
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Tabs/Tabs.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,2EAA2E;IAC3E,wEAAwE;AAC5E","sourcesContent":[".main {\n    display: flex;\n    gap: 12px;\n}\n\n.tab {\n    --padding-bottom: 6px;\n    --border-bottom-width: 2px;\n    padding-bottom: var(--padding-bottom);\n    cursor: pointer;\n}\n\n.tab.active {\n    border-bottom: var(--border-bottom-width) solid var(--color-secondary-dark);\n    padding-bottom: calc(var(--padding-bottom) - var(--border-bottom-width));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Tabs-module__main--OAY_W`,
	"tab": `Tabs-module__tab--nCgpc`,
	"active": `Tabs-module__active--JvZ9G`
};
export default ___CSS_LOADER_EXPORT___;
